import { useSyncExternalStore } from 'react';
import { applyUpdate, dismissUpdate, getUpdateState, subscribeUpdate } from '../services/swUpdate';
import styles from './UpdateBanner.module.css';

/**
 * A calm, non-blocking "A new version is ready" notice (13-08). Replaces the service worker's
 * blocking `confirm()` (RESEARCH Pitfall 6). It never interrupts: the person reloads when they
 * are ready, or chooses Later and keeps working.
 */
export default function UpdateBanner() {
  const { ready } = useSyncExternalStore(subscribeUpdate, getUpdateState, getUpdateState);
  if (!ready) return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <span className={styles.dot} aria-hidden="true" />
      <p className={styles.text}>A new version of Harmony QMS is ready.</p>
      <button type="button" className={styles.reload} onClick={() => applyUpdate()}>
        Reload
      </button>
      <button type="button" className={styles.later} onClick={() => dismissUpdate()}>
        Later
      </button>
    </div>
  );
}
